<template>
  <div>
    <b-modal
      title="匯出帳單"
      size="xl"
      centered
      hide-footer
      header-class="head-modal"
      v-model="modalShow"
    >
      <b-form-radio-group
        v-model="data.type"
        :options="options.type"
      ></b-form-radio-group>

      <div class="text-center mt-4">
        <b-button
          class="mr-2"
          variant="success"
          size="sm"
          @click="sumit()"
        >
          確定
        </b-button>
        <b-button
          variant="danger"
          size="sm"
          class="mr-4"
          @click="$emit('change', false)"
        >
          取消
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import billApi from "@/models/API/billApi";
import { downloadFile } from "@/models/HELPERS/common.js";

export default {
  name: 'ExportBillModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data () {
    return {
      options: {
        type: [
          { value: 1, text: '未繳費帳單' },
          { value: 2, text: '二期未繳名單' },
          { value: 3, text: '三期未繳名單' },
          { value: 4, text: '二期未繳要助人名單' },
        ],
      },
      data: {
        type: 1
      }
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },
  mounted() {
    this.billApi = new billApi();
  },
  methods: {
    // 匯出未繳費帳單
    sumit() {
      this.billApi.exportBill((response) => {
        if (!response) return;

        downloadFile(response);

        this.$emit('change', false);
      }, this.data)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/modal/ExportBillModal.vue